// extracted by mini-css-extract-plugin
export default {"NavigationItem":"nav_NavigationItem__IAILM","active":"nav_active__xOoon","visited":"nav_visited__s1X1a"};